import * as angular from 'angular';

class GroupSpacesController {}

export const GroupSpacesComponent: angular.IComponentOptions = {
  controller: GroupSpacesController,
  controllerAs: 'ctrl',
  bindings: {},
  template: `
    <group-spaces-browser
      org-token="ctrl.$resolve.orgToken"
      group-token="ctrl.$resolve.groupToken"
    />
  `,
};
